import { Link } from 'react-router-dom';
import { wines } from '@/mocks/products';

// Professional backgrounds - all with dark black grapes for red/rosé/bordo, white grapes for white
const wineBackgrounds = [
  // Bordô seco - very dark black grapes
  'https://public.readdy.ai/ai/img_res/edited_adfaf27c297ed2e9b4a63fcdfab78863_5b0e9cb3.jpg',
  // Branco seco Niágara - white/green Niagara grapes
  'https://public.readdy.ai/ai/img_res/edited_db8189690cae65be8c430be61fc1fa90_4860c490.jpg',
  // Casca-grossa rosé - rose-pink grapes
  'https://public.readdy.ai/ai/img_res/edited_f06642b839770337f4a0f4afccb3dd48_7184528f.jpg',
  // Tinto suave - very dark black grapes
  'https://public.readdy.ai/ai/img_res/edited_8bff8163727e058a25f2276660687aef_93abf2f1.jpg',
  // Vinho diferenciado seco - rosy pink grapes
  'https://public.readdy.ai/ai/img_res/edited_e95419cd0fc62bcd4913b70720eabbd7_958c0318.jpg',
];

const WinesSection = () => {
  return (
    <section className="py-20 md:py-28" style={{ background: '#2C0000', fontFamily: "'Sora', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-14 h-px bg-[#878450]/50"></div>
            <i className="ri-goblet-line text-[#878450] text-lg"></i>
            <div className="w-14 h-px bg-[#878450]/50"></div>
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold text-[#FCF1D7] mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Nossos Vinhos
          </h2>
          <p className="text-[#FCF1D7]/55 text-sm md:text-base max-w-lg mx-auto leading-relaxed">
            Vinhos excepcionais de ótima qualidade por preços super acessíveis.
          </p>
        </div>

        {/* Wine Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6 items-end">
          {wines.map((wine, index) => (
            <div
              key={wine.id}
              className="group relative rounded-3xl overflow-hidden cursor-pointer flex flex-col"
              style={{ height: '700px' }}
            >
              {/* Background — blurred 50% via CSS filter */}
              <div className="absolute inset-0 w-full h-full overflow-hidden">
                <img
                  src={wineBackgrounds[index]}
                  alt={`${wine.name} - uvas`}
                  className="w-full h-full object-cover object-center"
                  style={{
                    filter: 'blur(3px) brightness(0.85)',
                    transform: 'scale(1.06)',
                    transition: 'transform 0.7s ease',
                  }}
                />
              </div>

              {/* Color overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#2C0000]/92 via-[#2C0000]/30 to-[#2C0000]/10"></div>

              {/* Tag */}
              <div className="absolute top-5 left-5 z-20">
                <span className="bg-[#710005]/90 backdrop-blur-sm text-[#FCF1D7] text-xs font-semibold px-3 py-1.5 rounded-full">
                  {wine.tag}
                </span>
              </div>

              {/* Bottle — bigger and more prominent */}
              <div
                className="absolute z-10 flex justify-center items-end"
                style={{ top: '30px', left: 0, right: 0, height: '420px' }}
              >
                <img
                  src={wine.image}
                  alt={wine.name}
                  className="object-contain transition-all duration-500 group-hover:-translate-y-4"
                  style={{
                    height: '420px',
                    width: 'auto',
                    maxWidth: '88%',
                    objectFit: 'contain',
                    objectPosition: 'center bottom',
                    filter: 'drop-shadow(0 12px 32px rgba(0,0,0,0.65))',
                  }}
                />
              </div>

              {/* Bottle base / shelf effect */}
              <div
                className="absolute z-15 left-0 right-0"
                style={{ bottom: '148px' }}
              >
                <div className="mx-auto w-28 h-2 rounded-full bg-black/30 blur-sm"></div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 z-20 p-6">
                <span className="inline-block text-[#878450] text-xs font-semibold tracking-widest uppercase mb-1.5">
                  {wine.type}
                </span>
                <h3
                  className="text-[#FCF1D7] font-bold text-2xl mb-2 leading-tight"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {wine.name}
                </h3>
                <p className="text-[#FCF1D7]/60 text-xs leading-relaxed mb-5 line-clamp-2">
                  {wine.description}
                </p>
                <div className="flex items-center justify-between border-t border-[#878450]/20 pt-4">
                  <span className="text-[#FCF1D7]/45 text-xs tracking-wide">{wine.volume} · PET</span>
                  <Link
                    to="/vinhos"
                    className="flex items-center gap-2 bg-[#878450]/15 hover:bg-[#878450]/30 border border-[#878450]/30 text-[#878450] text-xs font-semibold px-4 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap"
                  >
                    Ver mais <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-14">
          <Link
            to="/vinhos"
            className="inline-flex items-center gap-3 px-10 py-4 rounded-full border border-[#878450]/40 text-[#878450] text-sm font-semibold hover:bg-[#878450]/10 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-goblet-line"></i>
            Ver Página Completa dos Vinhos
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WinesSection;
